module.exports = __webpack_public_path__ + "img/12.f7f4234a.webp";